import React, { useState } from "react";
import { X } from "lucide-react";
import { PaymentMarks } from "./PaymentMarks";

export const LaunchBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const scrollToSignup = (e) => {
    e.preventDefault();
    const el = document.querySelector("#signup");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[#0C2D48] text-white">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3 relative">
        <a
          href="#signup"
          onClick={scrollToSignup}
          className="flex items-center gap-2 text-sm sm:text-base font-semibold hover:opacity-90 transition-opacity"
        >
          <span className="inline-block w-2 h-2 rounded-full bg-[#16C79A] animate-pulse" />
          <span>
            Launch Price: <span className="text-[#16C79A]">99 AED</span> per month!
          </span>
          <span className="text-white/50 text-xs sm:text-sm font-normal ml-1 hidden sm:inline">
            — Sign up now
          </span>
        </a>
        <PaymentMarks variant="pill" size="xs" />
        <button
          onClick={() => setVisible(false)}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white transition-colors"
          aria-label="Dismiss banner"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
